import { useMemo } from "react";
import { experimentsApi } from "../store";

export const useExperimentTracking = (isSignedIn = false) => {
  const { data: experiments } = experimentsApi.useGetExperimentsQuery(
    undefined,
    { skip: !isSignedIn }
  );

  return useMemo(() => {
    if (experiments != null && experiments.trackingProperties != null) {
      return {
        experiments: Object.keys(experiments.trackingProperties).map(
          (ex) => `${ex}_${experiments.trackingProperties[ex]}`
        ),
      };
    }

    return {};
  }, [experiments]);
};
